import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle
            cx="16"
            cy="16"
            fill="#B1D5F6"
            r="13"
            stroke="#2A4F86"
            strokeWidth="2"
        />
        <circle cx="16" cy="23.5" fill="#2A4F86" r="1" stroke="#2A4F86" />
        <path
            d="M16 19V16H16.5C18.433 16 20 14.433 20 12.5V12.5C20 10.567 18.433 9 16.5 9H16C13.7909 9 12 10.7909 12 13V13"
            stroke="#2A4F86"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);

export default Icon;
